// This file is auto-generated. Run `pnpm generate:icons` to regenerate.
// biome-ignore-all assist/source/organizeImports: Generated file.
// biome-ignore-all format: Generated file.
import type { IconComponent, IconName } from "./icon-types";

type IconModule = { default: IconComponent };
type LazyIconName = Exclude<IconName, keyof typeof import("./core-icon-registry").coreIconRegistry>;

export const lazyIconNames = [
  "add-photo",
  "ai-filled",
  "ai",
  "alert-exclamation",
  "alerts-outline",
  "alerts",
  "angles-up-down-solid",
  "api",
  "arrow-drop-down",
  "arrow-left-shrink-sidebar",
  "arrow-right-expand-sidebar",
  "arrow-right-regular",
  "arrow-right",
  "art-service",
  "asset",
  "assign-link",
  "barcode-scan-regular",
  "binoculars",
  "bookmark-regular",
  "bookmark-solid",
  "calendar-solid",
  "camera-regular",
  "chart-line",
  "check-circle",
  "checklist",
  "circle-minus-solid",
  "circle-navigation",
  "circle-play-solid",
  "circle-plus-regular",
  "circle-question",
  "circle-stop-regular",
  "circle-xmark-solid",
  "clock-seven",
  "cloud-slash-regular",
  "collect",
  "collection-taken",
  "command-search",
  "component",
  "configure-slider",
  "cost-savings-dollar",
  "customers",
  "document-upload",
  "document",
  "dollar-sign",
  "dot",
  "drag",
  "edit-pen",
  "email-envelope",
  "expand-regular",
  "expand",
  "eye-slash-regular",
  "facilities",
  "flash-auto",
  "flash-off",
  "flash-on",
  "gauge-max-solid-full",
  "grid",
  "grip-drag",
  "hardware",
  "hazardous",
  "home",
  "hwe-sensor-triangle",
  "image-regular",
  "integrations",
  "invoke-reading-bolt-regular",
  "invoke-reading-bolt-solid",
  "line",
  "list",
  "location-pin-solid",
  "logout-exit",
  "maintenance",
  "marketplace",
  "message",
  "microphone-solid",
  "minus",
  "monitoring-point",
  "new-message",
  "new-nxt-step",
  "note-regular",
  "paper-plane-top",
  "partners",
  "phone",
  "qr-code-scan",
  "quarterly-collection",
  "report-error-square-regular",
  "rotate",
  "save",
  "send",
  "service",
  "settings-cog-solid",
  "share",
  "signal-connection",
  "signal",
  "sort-lines",
  "stacked-images-regular",
  "star-recommended",
  "sync",
  "tag",
  "temperature-high-regular-full",
  "thumbs-down",
  "thumbs-up",
  "trash-delete-bin",
  "trend-down",
  "trend-no-change",
  "trend-up",
  "triangle-exclamation-solid",
  "up-down",
  "user",
  "vero",
  "vibration",
  "watching",
  "wifi-exclamation-sharp-solid",
  "wifi",
  "workorder",
  "zoom-in",
  "zoom-out",
] as const satisfies readonly LazyIconName[];

export const lazyIconLoaders = {
  "add-photo": () => import("./generated/add-photo"),
  "ai-filled": () => import("./generated/ai-filled"),
  "ai": () => import("./generated/ai"),
  "alert-exclamation": () => import("./generated/alert-exclamation"),
  "alerts-outline": () => import("./generated/alerts-outline"),
  "alerts": () => import("./generated/alerts"),
  "angles-up-down-solid": () => import("./generated/angles-up-down-solid"),
  "api": () => import("./generated/api"),
  "arrow-drop-down": () => import("./generated/arrow-drop-down"),
  "arrow-left-shrink-sidebar": () => import("./generated/arrow-left-shrink-sidebar"),
  "arrow-right-expand-sidebar": () => import("./generated/arrow-right-expand-sidebar"),
  "arrow-right-regular": () => import("./generated/arrow-right-regular"),
  "arrow-right": () => import("./generated/arrow-right"),
  "art-service": () => import("./generated/art-service"),
  "asset": () => import("./generated/asset"),
  "assign-link": () => import("./generated/assign-link"),
  "barcode-scan-regular": () => import("./generated/barcode-scan-regular"),
  "binoculars": () => import("./generated/binoculars"),
  "bookmark-regular": () => import("./generated/bookmark-regular"),
  "bookmark-solid": () => import("./generated/bookmark-solid"),
  "calendar-solid": () => import("./generated/calendar-solid"),
  "camera-regular": () => import("./generated/camera-regular"),
  "chart-line": () => import("./generated/chart-line"),
  "check-circle": () => import("./generated/check-circle"),
  "checklist": () => import("./generated/checklist"),
  "circle-minus-solid": () => import("./generated/circle-minus-solid"),
  "circle-navigation": () => import("./generated/circle-navigation"),
  "circle-play-solid": () => import("./generated/circle-play-solid"),
  "circle-plus-regular": () => import("./generated/circle-plus-regular"),
  "circle-question": () => import("./generated/circle-question"),
  "circle-stop-regular": () => import("./generated/circle-stop-regular"),
  "circle-xmark-solid": () => import("./generated/circle-xmark-solid"),
  "clock-seven": () => import("./generated/clock-seven"),
  "cloud-slash-regular": () => import("./generated/cloud-slash-regular"),
  "collect": () => import("./generated/collect"),
  "collection-taken": () => import("./generated/collection-taken"),
  "command-search": () => import("./generated/command-search"),
  "component": () => import("./generated/component"),
  "configure-slider": () => import("./generated/configure-slider"),
  "cost-savings-dollar": () => import("./generated/cost-savings-dollar"),
  "customers": () => import("./generated/customers"),
  "document-upload": () => import("./generated/document-upload"),
  "document": () => import("./generated/document"),
  "dollar-sign": () => import("./generated/dollar-sign"),
  "dot": () => import("./generated/dot"),
  "drag": () => import("./generated/drag"),
  "edit-pen": () => import("./generated/edit-pen"),
  "email-envelope": () => import("./generated/email-envelope"),
  "expand-regular": () => import("./generated/expand-regular"),
  "expand": () => import("./generated/expand"),
  "eye-slash-regular": () => import("./generated/eye-slash-regular"),
  "facilities": () => import("./generated/facilities"),
  "flash-auto": () => import("./generated/flash-auto"),
  "flash-off": () => import("./generated/flash-off"),
  "flash-on": () => import("./generated/flash-on"),
  "gauge-max-solid-full": () => import("./generated/gauge-max-solid-full"),
  "grid": () => import("./generated/grid"),
  "grip-drag": () => import("./generated/grip-drag"),
  "hardware": () => import("./generated/hardware"),
  "hazardous": () => import("./generated/hazardous"),
  "home": () => import("./generated/home"),
  "hwe-sensor-triangle": () => import("./generated/hwe-sensor-triangle"),
  "image-regular": () => import("./generated/image-regular"),
  "integrations": () => import("./generated/integrations"),
  "invoke-reading-bolt-regular": () => import("./generated/invoke-reading-bolt-regular"),
  "invoke-reading-bolt-solid": () => import("./generated/invoke-reading-bolt-solid"),
  "line": () => import("./generated/line"),
  "list": () => import("./generated/list"),
  "location-pin-solid": () => import("./generated/location-pin-solid"),
  "logout-exit": () => import("./generated/logout-exit"),
  "maintenance": () => import("./generated/maintenance"),
  "marketplace": () => import("./generated/marketplace"),
  "message": () => import("./generated/message"),
  "microphone-solid": () => import("./generated/microphone-solid"),
  "minus": () => import("./generated/minus"),
  "monitoring-point": () => import("./generated/monitoring-point"),
  "new-message": () => import("./generated/new-message"),
  "new-nxt-step": () => import("./generated/new-nxt-step"),
  "note-regular": () => import("./generated/note-regular"),
  "paper-plane-top": () => import("./generated/paper-plane-top"),
  "partners": () => import("./generated/partners"),
  "phone": () => import("./generated/phone"),
  "qr-code-scan": () => import("./generated/qr-code-scan"),
  "quarterly-collection": () => import("./generated/quarterly-collection"),
  "report-error-square-regular": () => import("./generated/report-error-square-regular"),
  "rotate": () => import("./generated/rotate"),
  "save": () => import("./generated/save"),
  "send": () => import("./generated/send"),
  "service": () => import("./generated/service"),
  "settings-cog-solid": () => import("./generated/settings-cog-solid"),
  "share": () => import("./generated/share"),
  "signal-connection": () => import("./generated/signal-connection"),
  "signal": () => import("./generated/signal"),
  "sort-lines": () => import("./generated/sort-lines"),
  "stacked-images-regular": () => import("./generated/stacked-images-regular"),
  "star-recommended": () => import("./generated/star-recommended"),
  "sync": () => import("./generated/sync"),
  "tag": () => import("./generated/tag"),
  "temperature-high-regular-full": () => import("./generated/temperature-high-regular-full"),
  "thumbs-down": () => import("./generated/thumbs-down"),
  "thumbs-up": () => import("./generated/thumbs-up"),
  "trash-delete-bin": () => import("./generated/trash-delete-bin"),
  "trend-down": () => import("./generated/trend-down"),
  "trend-no-change": () => import("./generated/trend-no-change"),
  "trend-up": () => import("./generated/trend-up"),
  "triangle-exclamation-solid": () => import("./generated/triangle-exclamation-solid"),
  "up-down": () => import("./generated/up-down"),
  "user": () => import("./generated/user"),
  "vero": () => import("./generated/vero"),
  "vibration": () => import("./generated/vibration"),
  "watching": () => import("./generated/watching"),
  "wifi-exclamation-sharp-solid": () => import("./generated/wifi-exclamation-sharp-solid"),
  "wifi": () => import("./generated/wifi"),
  "workorder": () => import("./generated/workorder"),
  "zoom-in": () => import("./generated/zoom-in"),
  "zoom-out": () => import("./generated/zoom-out"),
} satisfies Record<LazyIconName, () => Promise<IconModule>>;

export type { LazyIconName };